import { PauseCircle } from "lucide-react";
import { useState } from "react";
import { TouchSheet as Sheet } from "../TouchSheet";

export function DowntimeConfirmSheet({
  lineName,
  machineConfigured,
  saving,
  close,
  confirm,
}: {
  lineName: string;
  machineConfigured: boolean;
  saving: boolean;
  close: () => void;
  confirm: () => void;
}) {
  return (
    <Sheet title="İşi duraklat?" close={close}>
      <div className="touch-form downtime-confirmation">
        <PauseCircle size={38} aria-hidden="true" />
        <p>
          <strong>{lineName}</strong> {machineConfigured ? "hattına durdurma isteği gönderilir. Duruş, makineden doğrulandığında kaydedilir." : "hattında iş açık kalır ve duruş süresi başlar. Makineyi fiziksel olarak durdurun."}
        </p>
        <footer className="touch-form-actions">
          <button type="button" className="touch-cancel" onClick={close}>Vazgeç</button>
          <button type="button" className="touch-save is-stop" disabled={saving} onClick={confirm}>{saving ? "Kaydediliyor…" : "İşi duraklat"}</button>
        </footer>
      </div>
    </Sheet>
  );
}

export function OperatorComplaintSheet({
  saving,
  close,
  submit,
}: {
  saving: boolean;
  close: () => void;
  submit: (description: string) => Promise<unknown>;
}) {
  const [description, setDescription] = useState("");
  return (
    <Sheet title="Şikayet bildir" close={close}>
      <div className="touch-form operator-complaint-form">
        <label className="touch-note">
          <span>Açıklama <small>Zorunlu</small></span>
          <textarea
            autoFocus
            autoCapitalize="sentences"
            enterKeyHint="done"
            inputMode="text"
            spellCheck
            maxLength={500}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            placeholder="Sorunu kısa ve açık şekilde yazın"
            rows={5}
          />
        </label>
        <footer className="touch-form-actions">
          <button type="button" className="touch-cancel" onClick={close}>Vazgeç</button>
          <button type="button" className="touch-save" disabled={saving || !description.trim()} onClick={() => void submit(description.trim())}>
            {saving ? "Gönderiliyor…" : "Amire gönder"}
          </button>
        </footer>
      </div>
    </Sheet>
  );
}

export function ReasonSheet({
  title,
  text,
  action,
  saving,
  close,
  submit,
  reasonRequired = true,
}: {
  title: string;
  text: string;
  action: string;
  saving: boolean;
  close: () => void;
  submit: (reason: string) => Promise<unknown>;
  reasonRequired?: boolean;
}) {
  const [reason, setReason] = useState("");
  return (
    <Sheet title={title} close={close}>
      <div className="touch-form correction-form">
        <p>{text}</p>
        <label className="touch-note">
          <span>
            Neden <small>{reasonRequired ? "Zorunlu" : "İsteğe bağlı"}</small>
          </span>
          <textarea
            autoFocus
            autoCapitalize="sentences"
            enterKeyHint="done"
            inputMode="text"
            spellCheck
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            placeholder="Kısa ve açıklayıcı bir neden yazın"
            rows={3}
          />
        </label>
        <footer className="touch-form-actions">
          <button type="button" className="touch-cancel" onClick={close}>
            Vazgeç
          </button>
          <button
            className="touch-save"
            disabled={saving || (reasonRequired && !reason.trim())}
            onClick={() => void submit(reason.trim())}
          >
            {saving ? "Kaydediliyor…" : action}
          </button>
        </footer>
      </div>
    </Sheet>
  );
}
